const ALWAYS_EXCLUDED_ROUTES = ["/checkout"];

const HOMEPAGE = "/";

const routeCovers = (pathname) => (route) =>
  route === HOMEPAGE ? pathname === HOMEPAGE : pathname.startsWith(route);

export const isNoticeShownOn =
  (pathname) =>
  ({ excludedRoutes }) =>
    ![...excludedRoutes, ...ALWAYS_EXCLUDED_ROUTES].some(routeCovers(pathname));
